import React, {useMemo} from 'react'

const MoreEventBox = ({data, onClick}) => {
  return (
    <div
      className={`event-box event-box--more`}
      onClick={e => onClick(data)}
      style={{
        top: data.top + '%',
        bottom: 100 - data.bottom + '%',
        left: data.left + 'px',
        width: data.right - 7 + 'px',
      }}
      title={data.title}
    >
      {data.title}
    </div>
  )
}

export default MoreEventBox
